import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DateTime, Interval } from "luxon";
import { UIChart } from "primeng/chart";
import { CopyToClipboardService } from "src/app/shared/services/copy-to-clipboard.service";
import { WidgetsService } from "src/app/shared/services/widgets.service";

@Component({
  selector: "widget-form-stats",
  templateUrl: "./widget-form-stats.component.html",
  styleUrls: ["./widget-form-stats.component.scss"],
})
export class WidgetFormStatsComponent implements OnInit {
  @ViewChild("doughnutChart") doughnutChart: UIChart;
  @Input() widgetConfig;
  settings: any = {};
  widgetSize = 33;
  loading = false;
  failedToLoad: boolean = false;
  noData = false;
  data: any[] = [];
  total = 0;

  doughnutData = {
    labels: [],
    datasets: [],
  };

  doughnutOptions = {
    cutout: 90,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: (context) => {
          return [0, 1, 8, 9].includes(context.dataIndex) ? "#ffffff" : "#000000";
        },
        font: {
          weight: "bold",
          size: 16,
        },
        anchor: "center",
        align: "center",
        offset: 0,
      },
      tooltip: {
        enabled: true,
        displayColors: false,
        callbacks: {
          label: (context) => {
            const label: string[] = context.label.match(/.{1,30}/g)
            return label.length > 10 ? [...label.slice(0, 10), '...'] : label;
          },
        },
      },
    },
  };

  doughnutPlugins = [];

  colors = [
    "#4D71FE",
    "#8BA3FE",
    "#C1CDFF",
    "#E4EAFF",
    "#F1993B",
    "#F5C087",
    "#FADBBB",
    "#FDF0E2",
    "#39289F",
    "#9289CA",
  ];

  constructor(
    private widgetsService: WidgetsService,
    private copyToClipboardService: CopyToClipboardService
  ) {}

  ngOnInit() {
    this.settings = this.widgetConfig.widgetSettings;
    this.widgetSize = this.widgetConfig.widgetHorizontalPercentageSize;
    this.init();
  }

  async init() {
    this.loading = true;
    try {
      const res: any = await this.widgetsService
        .getFormStatsWidgetData(this.settings.dataSource, this.settings.valueSeparator)
        .toPromise();
      if (res.data.length === 0) {
        this.noData = true;
      } else {
        this.total = res.total;
        this.data = res.data.map((obj, index) => {
          return {
            count: obj.count,
            color: this.colors[index],
            label: obj.value || "N/A",
          };
        });
        const labels = this.data.map((obj) => obj.label);
        const datasets = [
          {
            label: "Values",
            data: this.data.map((obj) => obj.count),
            backgroundColor: [...this.colors],
            hoverOffset: 4,
          },
        ];
        this.doughnutData.labels = labels;
        this.doughnutData.datasets = datasets;
        this.doughnutChart?.refresh();
      }
      this.loading = false;
      this.failedToLoad = false;
    } catch (error) {
      this.loading = false;
      this.failedToLoad = true;
      console.log(error);
    }
  }

  reloadWidget() {
    this.init();
  }

  clickToCopy(stringToCopy: string) {
    this.copyToClipboardService.copyToClipboard(stringToCopy);
  }
}
